import BOMAPICall from "../service/BOMAPICall";
import ProductRepository from "./ProductRepository";
import produceClone from "../helper/produceClone";
import store from "src/storeWire";
import Helper from "src/helper/Helper";
import Constants from "src/helper/Constants";

class BOMRepository {

  createBOM = async (params) => {
    return await new BOMAPICall().createBOM(params);
  };

  createBlankBOM = async () => {
    const params = {
      bomName: '', erpPartNumber: '', quantity: 0, fromCart: false, ItemNumber: '',
      lifeCycleRisk: '', partNumber: '', customerPartNumber: '',
    }
    return await this.createBOM(params);
  };

  fetchBOMList = async (prams) => {
    const direct_res = await new BOMAPICall().fetchBOMList(prams);
    let bomList = {};
    let res = {};
    if (direct_res.bomList && direct_res.bomList.length > 0) {
      direct_res.bomList.map((v) => {
        bomList[v.bomId] = v;
      });
    }
    res.bomList = bomList;
    return res;
  };

  fetchProductCategoryList = async () => {
    return await new BOMAPICall().fetchProductCategoryList();
  };

  editBOMName = async (bomName, bomId) => {
    return await new BOMAPICall().editBOM({ bomName, bomId });
  };

  setBOMIsRematchFlag = async (bomId) => {
    return await new BOMAPICall().setBOMIsRematchFlag({ bomId });
  };

  addPartToBOM = async (params) => {
    return await new BOMAPICall().addPartToBOM(params);
  };

  getBomDetailByBomID = async (bomId) => {
    return await new BOMAPICall().getBomDetailByBomID({ bomId });
  };

  deleteBOMByBomID = async (bomId) => {
    return await new BOMAPICall().deleteBOMByBomID({ bomId });
  };

  copyBOMByBomID = async (params) => {
    return await new BOMAPICall().copyBOMByBomID(params);
  };

  getBomHealthByBomID = async (bomId) => {
    const bomHealthRes = await new BOMAPICall().getBomHealthByBomID({ bomId });

    if (!bomHealthRes || bomHealthRes.length === 0) {
      return [];
    }

    let totalCount = 0;
    const healthResult = [];

    bomHealthRes.forEach((v, i) => {
      if (i === 1) {
        totalCount = v.percentage.split('/')[1];
      }
      if (v.lifeCycleRisk) {
        const healthResultObj = {
          lifeCycleRisk: v.lifeCycleRisk.toLowerCase(),
          percentage: v.percentage || 0
        };
        healthResult.push(healthResultObj);
      }
    });

    const riskTypes = ['low', 'med', 'high', 'unknown'];
    riskTypes.forEach((risk) => {
      const found = healthResult.some(el => el.lifeCycleRisk === risk);
      if (!found) {
        const zeroHealthObj = {
          lifeCycleRisk: risk,
          percentage: `0/${totalCount}`
        };
        healthResult.push(zeroHealthObj);
      }
      healthResult.sort((a, b) => {
        const riskOrder = { low: 0, med: 1, high: 2, unknown: 3 };
        return riskOrder[a.lifeCycleRisk] - riskOrder[b.lifeCycleRisk];
      });
    });

    return healthResult;
  };

  bomDownloadFile = async (bomId, fileType, fieldColumns, currentCurrency) => {
    return await new BOMAPICall().bomDownloadFile({
      bomId,
      fileType,
      fieldColumns,
      currentCurrency
    });
  };

  bomEmailFile = async (bomId, fileType, fieldColumns, recipientEmail, senderEmail, message, currentCurrency) => {
    return await new BOMAPICall().bomEmailFile({
      bomId,
      fileType,
      fieldColumns,
      recipientEmail,
      senderEmail,
      message,
      currentCurrency
    });
  };

  saveDownloadFilePreference = async (content = {}) => {
    if (content?.prefType) {
      return await new BOMAPICall().saveDownloadFilePreference(content);
    }
    return await new BOMAPICall().saveDownloadFilePreference({
      preferenceValue: JSON.stringify(content)
    });
  };

  fetchDownloadFilePreference = async (params = {}) => {
    return await new BOMAPICall().fetchDownloadFilePreference(params);
  };

  getBomDetailByBomIDWithType = async (bomId, matchType, sortColumn, sortOrder, isReRunPartMatch = false, top = 10, force_all_skip_redux_check = false, callFrom = '', skip = 0) => {
    const res = await new BOMAPICall().getBomDetailByBomIDWithType({
      bomId,
      matchType,
      isReRunPartMatch,
      top,
      force_all_skip_redux_check,
      sortColumn, sortOrder, // 10889
      skip
    });

    const defaultValue = () => ({
      totalMatches: 0,
      isExternalBom: false,
      bomColumnMapping: {},
      downloadColumnList: {},
      UnMatch: { count: 0, records: {}, matchType: 'UnMatch' },
      Exact: { count: 0, deleted: 0, records: {}, matchType: Constants.bomDetailPageTabs.BomExactMatchTable.api_fetch_type },
      Multiple: { count: 0, deleted: 0, records: {}, matchType: Constants.bomDetailPageTabs.BomMultipleMatchTable.api_fetch_type },
      NoMatch: { count: 0, deleted: 0, records: {}, matchType: Constants.bomDetailPageTabs.BomNoMatchTable.api_fetch_type }
    });

    const processData = async (data) => {
      let processedData = defaultValue();
      if (data.bomDetailsMatchType && Array.isArray(data.bomDetailsMatchType)) {
        data.bomDetailsMatchType.forEach((v) => {
          processedData[v.matchType] = { records: {}, count: v.count, deleted: v.deleted, matchType: v.matchType };
        });
      }

      if (data.downloadColumnList && Array.isArray(data.downloadColumnList)) {
        data.downloadColumnList.forEach((v) => {
          processedData.downloadColumnList[Helper.anythingToCamel(v)] = {
            fileColumnName: v,
            columnName: Helper.anythingToCamel(v)
          };
        });
      }

      if (data.bomMatches && Array.isArray(data.bomMatches)) {
        data.bomMatches.map((v) => {
          v.ERPPartNumber = v.erpPartNumber;
          v.ItemNumber = v.itemNumber;
          v.manufacturerPartNumber = v.manufacturerPartNumber || v.partNumber;
          v.uniqueId = v.bomDetailId;
          processedData[v.matchType].records[v.bomDetailId] = v;
        });

      }
      if (data?.bomColumnMapping && Array.isArray(data.bomColumnMapping)) {
        processedData.bomColumnMapping = data.bomColumnMapping.reduce((acc, v) => {
          acc[v.columnName] = v;
          return acc;
        }, {});
      }

      processedData.totalMatches = data.totalMatches || 0;
      processedData.isExternalBom = data.isExternalBom || false;
      
      return processedData;
    };
    const processedResponse = await processData(res);

    if (processedResponse.Exact.records && callFrom !== 'Download' && matchType == Constants.bomDetailPageTabs.BomExactMatchTable.api_fetch_type) {
      let p_res = await new ProductRepository().getProductPriceInventoryAssets(processedResponse.Exact.records, true, true);
      p_res = await new BOMAPICall().attachBOMAlternativeToBOMDetailAPICall(processedResponse.Exact.records);
      processedResponse.Exact.records = produceClone(p_res);
    }

    let state = store.getState();
    if (skip === 0) {
      return { data: processedResponse };
    } else {
      let records = JSON.parse(JSON.stringify(state.entities.model_BOM.bomDetailByBomIDWithType));
      if (Object.entries(records).length > 0) {
        Object.keys(processedResponse).forEach((matchType) => {
          if (records[matchType] && records[matchType].records) {
            processedResponse[matchType].records = {
              ...records[matchType].records,
              ...processedResponse[matchType].records
            };
          }
        });
      }

      return { data: processedResponse };
    }
  };


  getBomDetailCountByBomID = async (bomId) => {
    const res = await new BOMAPICall().getBomDetailByBomIDWithType({
      bomId,
      matchType: 'NoMatch',
      isReRunPartMatch: false,
      top: 1,
      force_all_skip_redux_check: false
    });
    const final_res = {};

    if (res.bomDetailsMatchType) {
      res.bomDetailsMatchType.forEach(item => {
        if (item.matchType && item.count > -1) {
          final_res[item.matchType] = {
            count: item.count,
            deleted:item.deleted
          };
        }
      });
    }

    return final_res;
  };

  downloadBomTemplate = async () => {
    return await new BOMAPICall().downloadBomTemplate();
  };

  createPartList = async (bomId, partList) => {
    return await new BOMAPICall().createPartList({ bomId, partList });
  };

  assignBOMToProject = async (bomId, projectId) => {
    return await new BOMAPICall().assignBOMToProject({ bomId, projectId });
  };

  swapPartNumber = async (params) => {
    return await new BOMAPICall().swapPartNumber(params);
  };

  updateQuantityByBomDetailID = async (params) => {
    return await new BOMAPICall().updateQuantityByBomDetailID(params);
  };

  updateCustomerPartNumberByBomDetailID = async (params) => {
    return await new BOMAPICall().updateCustomerPartNumberByBomDetailID(params);
  };

  removePartNumber = async (bomDetailId, bomId) => {
    return await new BOMAPICall().removePartNumber({ bomDetailId, bomId });
  };

  getMultipleMatchProductSearch = async (bomDetailId, getRawData = true) => {
    const res = await new BOMAPICall().getMultipleMatchProductSearch({ bomDetailId });
    if (getRawData === true) {
      return res;
    }
    if (res.Products) {
      return res.Products;
    }
  };
  mergeGuestBomItem = async () => {
    const params = {
      ItemNumber: '',
      erpPartNumber: '',
      lifeCycleRisk: '',
    }
    return await new BOMAPICall().mergeGuestBomItem(params);
  };

  static loadMore(top, props) {
    const t = JSON.parse(JSON.stringify(top));
    if (t[props.current_chain.api_fetch_type] && t[props.current_chain.api_fetch_type].top) {
      t[props.current_chain.api_fetch_type].top = t[props.current_chain.api_fetch_type].top + 10;
    } else {
      t[props.current_chain.api_fetch_type] = {};
      t[props.current_chain.api_fetch_type].top = 30;
    }
    return t;
  }

  static getBOMAlertClass(message) {
    if (message) {
      return (message.includes('exceeded 1000 lines') ||
        message.includes('altered to meet the file')) ? 'warning' : 'danger';
    } else {
      return 'danger';
    }
  }

  createParamsForAddPartToBom = (param, fromCart = false) => {
    let state = store.getState();
    const CART_BEFORE_TO_SEND_SERVER = state.entities.Cart.CART_BEFORE_TO_SEND_SERVER[param?.ItemNumber];

    let params = {}
    params.bomName = param?.bomName ? param.bomName : ''
    params.ERPPartNumber = param?.ERPPartNumber ? param.ERPPartNumber : ''
    params.ManufacturerPartNumber = param?.ManufacturerPartNumber ? param.ManufacturerPartNumber : ''
    params.ItemNumber = param?.ItemNumber ? param.ItemNumber : ''
    params.quantity = CART_BEFORE_TO_SEND_SERVER?.quantityUpdateToCart ? CART_BEFORE_TO_SEND_SERVER?.quantityUpdateToCart : param?.QtyMin ? param.QtyMin : 0
    params.LifeCycleRisk = param?.LifeCycleRisk ? param.LifeCycleRisk : ''
    params.fromCart = fromCart
    params.ERPMFRPartNumber = param?.ERPMFRPartNumber ? param.ERPMFRPartNumber : ''
    params.PartNumber = param?.ERPMFRPartNumber ? param.ERPMFRPartNumber : '';
    params.bomIds = param?.bomIds
    if (CART_BEFORE_TO_SEND_SERVER?.CPN || param?.selectedSearchCPN) {
      params.customerPartNumber = param?.selectedSearchCPN ? param.selectedSearchCPN : CART_BEFORE_TO_SEND_SERVER?.CPN
    }

    return params;
  }

  fetchStaticColumns = async () => {
    return await new BOMAPICall().fetchStaticColumns();
  };

  fetchSavedColumnsDataByBomID = async (bomId) => {
    return await new BOMAPICall().fetchSavedColumnsDataByBomID({ bomId });
  };

  fetchSavedColumnsPreferenceByBomID = async (params) => {
    return await new BOMAPICall().fetchSavedColumnsPreferenceByBomID(params);
  };

  saveColumnsPreferenceByBomID = async (params) => {
    return await new BOMAPICall().saveColumnsPreferenceByBomID(params);
  };

  UsersWithAbandonedBomFor72Hours = async (params) => {
    return await new BOMAPICall().UsersWithAbandonedBomFor72Hours(params);
  };

  deleteSingleProject = async (projectId) => {
    return await new BOMAPICall().deleteProject({ projectId });
  };

  editProject = async (params) => {
    return await new BOMAPICall().editProject(params);
  };

  createProject = async (params) => {
    return await new BOMAPICall().createProject(params);
  };

  listProjectDetailWithBOM = async (params) => {
    return await new BOMAPICall().listProjectDetailWithBOM(params);
  };

  listProject = async () => {
    return await new BOMAPICall().listProject();
  };

}

export default BOMRepository;